"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlpsToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_alpersDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "contract IAlpsDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
            {
                internalType: "contract IAlpsSeeder",
                name: "_seeder",
                type: "address",
            },
            {
                internalType: "contract IProxyRegistry",
                name: "_proxyRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "AlpBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                indexed: false,
                internalType: "struct IAlpsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "AlpCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "alpersDAO",
                type: "address",
            },
        ],
        name: "AlpersDAOUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DescriptorLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IAlpsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "DescriptorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MinterLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "SeederLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IAlpsSeeder",
                name: "seeder",
                type: "address",
            },
        ],
        name: "SeederUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DELEGATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "alpersDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "alpsCouncil",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "alpId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                internalType: "uint96",
                name: "votes",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "descriptor",
        outputs: [
            {
                internalType: "contract IAlpsDescriptorMinimal",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCurrentVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPriorVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDescriptorLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMinterLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSeederLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyRegistry",
        outputs: [
            {
                internalType: "contract IProxyRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seeder",
        outputs: [
            {
                internalType: "contract IAlpsSeeder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "seeds",
        outputs: [
            {
                internalType: "uint48",
                name: "background",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "body",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "accessory",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "head",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "glasses",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_alpersDAO",
                type: "address",
            },
        ],
        name: "setAlpersDAO",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_alpsCouncil",
                type: "address",
            },
        ],
        name: "setAlpsCouncil",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newContractURIHash",
                type: "string",
            },
        ],
        name: "setContractURIHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IAlpsDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
        ],
        name: "setDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IAlpsSeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        name: "setSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "votesToDelegate",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class AlpsToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_alpersDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.deploy(_alpersDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    getDeployTransaction(_alpersDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.getDeployTransaction(_alpersDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AlpsToken__factory = AlpsToken__factory;
AlpsToken__factory.bytecode = _bytecode;
AlpsToken__factory.abi = _abi;
